import { Component } from 'preact'
import { Regular, Small } from '../text'
import styles from './style.styl'
import { Arrow } from '../icons'
import { cc } from '../../utils'

class Accordion extends Component {
  render () {
    const {
      header,
      children,
      expanded = false,
      onHeaderClick
    } = this.props

    return (
      <div>
        <div
          className={styles.accordionHeader}
          onClick={onHeaderClick}
        >
          <Regular dangerouslySetInnerHTML={{ __html: header }} />
          <Arrow
            className={cc(
              styles.arrowIcon,
              expanded && styles.arrowIconActive
            )}
          />
        </div>
        {expanded && (
          <Small
            className={styles.accordionChildren}
            dangerouslySetInnerHTML={{ __html: children }}
          />
        )}
      </div>
    )
  }
}

export default Accordion



// WEBPACK FOOTER //
// ./components/faq/accordion.js